import { withTheming, themedFontFamily } from '@doordash/design-language';
import styled from 'styled-components';
import { LogoBrand } from './types.js';

var lineHeight = 1.5;
var LogoTextContainer = styled.div.withConfig({
  displayName: "styles__LogoTextContainer",
  componentId: "sc-uv595k-0"
})(["line-height:0;"]);
var TypeWrapper = styled.span.withConfig({
  displayName: "styles__TypeWrapper",
  componentId: "sc-uv595k-1"
})(["height:", "px;display:flex;align-items:center;"], function (_ref) {
  var height = _ref.height;
  return height;
});
var Type = withTheming(styled.span.withConfig({
  displayName: "styles__Type",
  componentId: "sc-uv595k-2"
})(["color:", ";font-family:", ";text-transform:uppercase;-webkit-font-smoothing:antialiased;letter-spacing:0.1ch;font-size:", "px;font-weight:", ";line-height:", "px;"], function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return theme.Colors[color] || color;
}, function (_ref3) {
  var brand = _ref3.brand;
  return themedFontFamily(brand === LogoBrand.Caviar ? 'Caviar-Market' : 'DD-TTNorms');
}, function (_ref4) {
  var size = _ref4.size;
  return size;
}, function (_ref5) {
  var brand = _ref5.brand;
  return brand === LogoBrand.Caviar ? 400 : 500;
}, function (_ref6) {
  var size = _ref6.size;
  return size * lineHeight;
}));

export { LogoTextContainer, Type, TypeWrapper };
